
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","stroke":"#000","d":"M6.254 9.103a567.048 567.048 0 000 0zm-.5-.008a.383.383 0 00-.003.003l.003-.003zM6 8.869c2.584-2.38 4.078-3.787 4.408-4.151.394-.434.592-.928.592-1.446C11 2.037 9.868 1 8.43 1a2.74 2.74 0 00-1.781.636L6 2.188l-.649-.552A2.747 2.747 0 003.57 1C2.132 1 1 2.037 1 3.272a2.1 2.1 0 00.56 1.414c.31.342 1.814 1.76 4.44 4.183z"}})])
          )
        }
      }
    